export default "__VITE_ASSET__B1n7Its6__"